import { memo } from "react";
import { twMerge } from "tailwind-merge";

import styles from "./Spinner.module.css";

const classNameBounce =
  "absolute size-full rounded-full opacity-60 top-0 left-0 bg-current ";

function Spinner({ className }: { className?: string }) {
  return (
    <div className={twMerge(`relative size-8`, className)}>
      <div className={twMerge(classNameBounce, styles.bounce1)}></div>
      <div className={twMerge(classNameBounce, styles.bounce2)}></div>
    </div>
  );
}

export default memo(Spinner);
